import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authcontext";
import { AccessDenied403 } from "../common/error_pages";

export default function ProtectedRoute({ children, requiredPerm, requiredAnyPerm }) {
  const { isAuthenticated, loading, hasPermission, hasAnyPermission } = useAuth();

  if (loading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (requiredPerm && !hasPermission(requiredPerm)) {
    return <AccessDenied403 requiredPerm={requiredPerm} />;
  }

  if (requiredAnyPerm && Array.isArray(requiredAnyPerm) && !hasAnyPermission(requiredAnyPerm)) {
    return <AccessDenied403 requiredPerm={requiredAnyPerm.join(" or ")} />;
  }

  return children;
}